import { clearFlagsFromFlagsManager } from '@databases/core-event-bus/listeners';
import { container } from '@databases/service-container';

import { type Recyclable } from '../types';

/**
 * Recyclable that clears client flags when bridge identity recycles. Uses `skipInitialSetup` so the first
 * `registerRecyclableModules` pass does not run `setup` (bootstrap already covered equivalent work).
 * Pass into {@link registerRecyclableModules} near the start of the list.
 */
export function createClearBridgeFlagsRecyclable(): Recyclable {
  return {
    skipInitialSetup: true,
    setup() {
      clearFlagsFromFlagsManager(container.resolve('FlagsManager'));
    },
    dispose() {},
  };
}
